/** Disables text selection, keyboard shortcuts, and context actions to prevent copying or pasting content inside the target element.*/
export function applyNoCopy(el: HTMLElement) {
  el.style.userSelect = "none";
  (el.style as any).webkitUserSelect = "none";
  (el.style as any).msUserSelect = "none";
  (el.style as any).webkitTouchCallout = "none";

  el.addEventListener("keydown", (e: KeyboardEvent) => {
    if (
      (e.ctrlKey || e.metaKey) &&
      ["c", "x", "a"].includes(e.key.toLowerCase())
    ) {
      e.preventDefault();
    }
  });

  ["copy", "cut", "paste", "contextmenu", "dragstart"].forEach(evt => {
    el.addEventListener(evt, e => e.preventDefault());
  });
}
